import { render, staticRenderFns } from "./update-status-sue.vue?vue&type=template&id=91593754&"
import script from "./update-status-sue.vue?vue&type=script&lang=js&"
export * from "./update-status-sue.vue?vue&type=script&lang=js&"
import style0 from "./update-status-sue.vue?vue&type=style&index=0&id=91593754&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports